import React from 'react';
import OpportunityImpactGraph from '../../../opportunities/OpportunityImpactGraph';
import OpportunityListContainer from '../../../opportunities/OpportunityListContainer';

const OrgOpportunitiesPage = props => {
    return(
        <div style={{margin:'auto'}}>
            <OpportunityListContainer userData={props.userData} isMobile={props.isMobile}/>
            {/* <OpportunityImpactGraph siteID={111} adminView={true}/> */}
        </div>
    )
}

export default OrgOpportunitiesPage;